import { Fragment, type ReactNode } from 'react';
import type { Placement } from '@floating-ui/react';
import { useAccessibleTooltip } from 'app/components/core/AccessibleTooltip';
import { Icon, type IconProps, IconSize } from 'app/components/core/Icon';

export interface Props extends Omit<IconProps, 'variant'> {
    children: ReactNode;
    placement?: Placement;
}

export function HintIcon({ children, placement = 'bottom', ...props }: Props) {
    const { Tooltip, getTooltipProps, getReferenceProps } = useAccessibleTooltip({
        placement
    });

    return (
        <Fragment>
            <Icon variant="info" size={IconSize.EXTRA_SMALL} {...getReferenceProps(props)} />
            <Tooltip {...getTooltipProps()}>{children}</Tooltip>
        </Fragment>
    );
}
